﻿import {translation} from "@2d-front-monorepo/core";

import {
	GeoapifyAddressComponent,
	GeoapifyResponseEntry,
	upperCase
} from "@2d-front-monorepo/design-library";

import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useCallback, useMemo} from "react";
import {API_ENDPOINT} from "../api-endpoint";
import {getGlobalContext} from "../hooks/getGlobalContext";
import getInstallationId from "../hooks/getInstallationId";
import {formatRoute} from "../routes";
import {BoundAddressComponentProps} from "./BoundAddressComponentProps";

export default function BoundedGeoapifyAddressComponent(props: BoundAddressComponentProps): JSX.Element {
	const {setAddress} = props;
	const {installation, languageId} = getGlobalContext();

	const onUserSelect = useCallback(async function (item: GeoapifyResponseEntry): Promise<void> {
		setAddress({
			street: item.street,
			streetNumber: item.housenumber,
			postalCode: item.postcode,
			state: upperCase(item.state),
			city: upperCase(item.city)
		});

	}, [setAddress, installation]);

	const filterResponse = useCallback(function (response: GeoapifyResponseEntry[]): GeoapifyResponseEntry[] {
		const map = new Map<string, GeoapifyResponseEntry>();
		for (const item of response) {
			if (map.has(item.street)) {
				continue;
			}

			map.set(item.street, item);
			item.formatted = `${item.housenumber} ${item.street}`;
		}
		return Array.from(map.values());
	}, []);

	const bounds = installation.geolocationBounds;
	const filter = useMemo(() => ({
		rect: {
			lon1: parseFloat(bounds.southWest.longitude),
			lat1: parseFloat(bounds.southWest.latitude),
			lon2: parseFloat(bounds.northEast.longitude),
			lat2: parseFloat(bounds.northEast.latitude)
		}
	}), [bounds]);

	return <GeoapifyAddressComponent baseURL={formatRoute(API_ENDPOINT.geolocation, getInstallationId())}
	                                 onSelect={onUserSelect}
	                                 onResponse={filterResponse}
	                                 autoFocus={true}
	                                 minChars={4}
	                                 label={translation(PermitTranslations.new_permit_page__find_address)}
	                                 language={languageId}
	                                 filter={filter}/>;
}
